import React, { useEffect, useState, useRef, useMemo } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { makeStyles, Grid, Box, Paper } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import { opportunityData } from "../../../shared-resources/dumpData";
import { convertValuesFM } from "../../../shared-resources/utils";
import Loading from "../../../common-components/Loading";
import { getOpportunitySpreadAPI } from "../../../api/financial-management-api";
import { format } from "highcharts";

const useStyles = makeStyles((theme) => ({
  tableTitle: {
    width: "180px",
    height: "36px",
    padding: "0 0 0 12px",
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#000",
    borderRadius: "0 10px 0 0",
    display: "flex",
    alignItems: "center",
  },
}));

const headers = [
  { type: "Revenue", format: "currency", code: "revenue" },
  { type: "Total Direct Cost", format: "currency", code: "totalDirectCost" },
  { type: "Direct Labor", format: "currency", code: "directLabor" },
  { type: "Subcontractor", format: "currency", code: "subcontractor" },
  { type: "ODCs", format: "currency", code: "odc" },
  { type: "Gross Profit", format: "currency", code: "grossProfit" },
  { type: "Gross Margin%", format: "percentage", code: "grossProfitPct" },
  { type: "Burdened Cost", format: "currency", code: "burdenedCost" },
  { type: "Net Profit", format: "currency", code: "netProfit" },
  { type: "Net Profit %", format: "percentage", code: "netProfitPct" },
];

const subHeaders = [
  "Revenue",
  "Total Direct Cost",
  "Gross Profit",
  "Burden Cost",
  "Net Profit",
];

const OpportunityDetails = ({ opp }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  const selectedOppYear = useSelector(
    (state) => state.financialManagementReducer.selectedOppYear
  );

  useEffect(() => {
    setLoading(true);
    getOpportunitySpreadAPI(opp.oppNo, selectedOppYear).then((res) => {
      if (res.status === 200) {
        setData(res.data);
        setLoading(false);
      }
    });
  }, [opp, selectedOppYear]);

  const formatValue = (val, type) => {
    if (type === "percentage") {
      if (val < 0) return `(${Math.abs(val).toFixed(2)}%)`;
      else return `${val.toFixed(2)}%`;
    } else if (type === "currency") {
      return convertValuesFM(val);
    }
    return val;
  };

  return (
    <>
      {data && (
        <Box style={{ marginTop: "12px" }} display="flex" flexDirection="row">
          <Box style={{ width: "180px", marginRight: "12px" }}>
            <div className={classes.tableTitle}>Opportunity Details</div>
            <Paper elevation={0} style={{ boxShadow: "0px 3px 6px #00000029" }}>
              <table
                className="opportunityDetailsTableFirst"
                cellPadding={0}
                cellSpacing={0}
              >
                <thead>
                  <tr>
                    <td>{opp.oppName}</td>
                  </tr>
                </thead>
                <tbody>
                  {headers.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          paddingLeft:
                            subHeaders.indexOf(item.type) >= 0
                              ? "12px"
                              : "24px",
                          fontWeight:
                            subHeaders.indexOf(item.type) >= 0 ? 600 : 400,
                        }}
                      >
                        {item.type}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Paper>
          </Box>
          <Box
            style={{
              boxShadow: "0px 3px 6px #00000029",
              backgroundColor: "#fff",
              overflowX: "auto",
              marginTop: "36px",
              width: "100%",
            }}
          >
            <table
              className="opportunityDetailsTableSecond"
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  {data.monthHeadingList.map((header, index) => (
                    <td key={index}>{header}</td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {headers.map((item, id) => (
                  <tr>
                    {data[item.code]
                      ? data.monthHeadingList.map((headItem, idx) => (
                          <td
                            style={{
                              fontWeight:
                                subHeaders.indexOf(item.type) >= 0 ? 600 : 400,
                              paddingLeft:
                                idx === 0
                                  ? subHeaders.indexOf(item.type) >= 0
                                    ? "12px"
                                    : "24px"
                                  : "4px",
                            }}
                          >
                            {data[item.code].filter(
                              (val) => val.displayName === headItem
                            ).length > 0
                              ? formatValue(
                                  data[item.code].filter(
                                    (val) => val.displayName === headItem
                                  )[0].data,
                                  item.format
                                )
                              : formatValue(0, item.format)}
                          </td>
                        ))
                      : ``}
                  </tr>
                ))}
              </tbody>
              {/* <tbody>
                {data.data.map((item, index) => (
                  <tr key={index}>
                    {item.values.map((value, idx) => (
                      <td
                        style={{
                          fontWeight:
                            subHeaders.indexOf(item.type) >= 0 ? 600 : 400,
                          paddingLeft:
                            idx === 0
                              ? subHeaders.indexOf(item.type) >= 0
                                ? "12px"
                                : "24px"
                              : "4px",
                        }}
                        key={idx}
                      >
                        {formatValue(value, item.format)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody> */}
            </table>
          </Box>
        </Box>
      )}

      {loading && <Loading />}
    </>
  );
};

export default OpportunityDetails;
